import { useStore } from "@/store";
import { useCallback, useEffect, useState } from "react";
import { db } from "@/firebase/app";
import { doc, getDoc } from "firebase/firestore";

export const useFetchWorkspaceById = (
    id: string | undefined,
    { setAsCurrent = true }: { setAsCurrent?: boolean } = {}
) => {
    const getWorkspaceById = useStore((state) => state.getWorkspaceById);
    const addWorkspace = useStore((state) => state.addWorkspace);
    const setCurrentWorkspace = useStore((state) => state.setCurrentWorkspace);
    const workspace = id ? getWorkspaceById(id) : null;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const fetchWorkspace = useCallback(
        async (id: string) => {
            setLoading(true);
            try {
                const snapshot = await getDoc(doc(db, "workspaces", id));
                const workspace = { ...snapshot.data(), id: snapshot.id };

                addWorkspace(workspace);

                if (setAsCurrent) {
                    setCurrentWorkspace(workspace);
                }
            } catch (error) {
                setError(error as Error);
            } finally {
                setLoading(false);
            }
        },
        [addWorkspace, setAsCurrent, setCurrentWorkspace]
    );

    useEffect(() => {
        if (id && !workspace) {
            fetchWorkspace(id);
        }
    }, [fetchWorkspace, workspace, id]);

    return { data: workspace, loading, error };
};
